import { api } from "@/lib/api";
import { logError } from "@/lib/log";

const SRC = "mm_tool_src";
const sent = new Set();

// Anonymous per-tool counts (no ids, no cookies). Visits/starts are counted once per page load.
export const track = (tool, type) => {
  const once = ["visit", "start", "finish", "shared_visit"].includes(type);
  if (once && sent.has(`${tool}:${type}`)) return;
  if (once) sent.add(`${tool}:${type}`);
  api.post("/tools/event", { tool, type }).catch((e) => logError("Tool event not recorded:", e));
};

export const rememberSource = (tool) => { try { sessionStorage.setItem(SRC, tool); } catch (e) { logError("Session storage unavailable:", e); } };
export const toolSource = () => { try { return sessionStorage.getItem(SRC); } catch (e) { logError("Session storage unavailable:", e); return null; } };
export const resetTrack = (tool) => ["start", "finish"].forEach((t) => sent.delete(`${tool}:${t}`));
